<script lang="ts">
  import '../../../app.postcss'
  import Footer from '../components/Footer.svelte'
  import ContactHero from './components/ContactHero.svelte'
  import FAQs from '../components/FAQs.svelte'
  import FollowUs from './components/FollowUs.svelte'
</script>

<div class="fade-in space-y-24 sm-desktop:space-y-52 lg-desktop:space-y-64">
  <ContactHero />
  <FollowUs />
  <FAQs />
  <Footer nextPage="Homepage" pageLink="/" />
</div>

<style lang="postcss">
  :global(body) {
    @apply bg-black p-0 text-white;
  }
</style>
